export default function ConfettiLayer() {
  return (
    <div
      id="confetti"
      className="confetti-layer"
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 200,
      }}
    />
  );
}
